<div class="alert" [ngClass]="[type]">
	<span><b> {{title}} - </b> {{content}}</span>
</div>
